import { useQuery } from '@tanstack/react-query';
import {
  getLocationServiceValue,
  getTimeZone,
  queryKeys,
} from '@vgrubs/components';

/**
 * What the client made and saved with us and what we made from it, all
 * time. Deliberately not the Overview's period: the cards sit above its date
 * picker and do not follow it, so the call goes out once per location.
 *
 * Taken straight from the backend, never summed from shorter periods: the
 * vDrive savings floor of 0 per brand applies to the whole range at once.
 */
export const useLocationServiceValue = ({
  locationId,
  enabled,
}: {
  locationId: number | string;
  /** Admin and support only: anyone else gets a 403. */
  enabled: boolean;
}) => {
  const query = useQuery({
    queryKey: queryKeys.locationInsights.serviceValue(locationId),
    queryFn: async () => {
      const { data } = await getLocationServiceValue(locationId, {
        timeZone: getTimeZone,
      });
      return data.data;
    },
    enabled,
  });

  return {
    value: query.data ?? null,
    isFetching: query.isFetching,
    isError: query.isError,
  };
};
